<template>
  <div class="zakat-donation-info-style-6">
    <!-- Simple Step Indicator -->
    <div class="step-indicator">
      <div class="step-item" :class="{ active: store.step === 1 }">
        <div class="step-number">1</div>
        <div class="step-label">Amount</div>
      </div>
      <div class="step-divider"></div>
      <div class="step-item" :class="{ active: store.step === 2 }">
        <div class="step-number">2</div>
        <div class="step-label">Details</div>
      </div>
      <div class="step-divider"></div>
      <div class="step-item" :class="{ active: store.step === 3 }">
        <div class="step-number">3</div>
        <div class="step-label">Payment</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
</script>

<style scoped>
.zakat-donation-info-style-6 {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
}

.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: white;
  border-bottom: 1px solid #e9ecef;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e9ecef;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

.step-item.active .step-number {
  background: #28a745;
  color: white;
}

.step-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  transition: all 0.3s ease;
}

.step-item.active .step-label {
  color: #28a745;
  font-weight: 600;
}

.step-divider {
  width: 40px;
  height: 2px;
  background: #e9ecef;
  margin: 0 16px;
}


/* Responsive adjustments */
@media (max-width: 480px) {
  .step-indicator {
    padding: 16px;
  }
  
  .step-divider {
    width: 20px;
    margin: 0 8px;
  }
  
  .zakat-info-panel {
    padding: 20px;
  }
  
}
</style>